import {
  TenantContextDocument,
  TenantContextDocumentApi,
  TenantContextDocumentsResponse,
} from '@/store/modules/tenantcontext/types'

export default {
  updateTenantContextDocuments(state: any, response: TenantContextDocumentsResponse) {
    const rawReferences: TenantContextDocumentApi[] = response && response.references ? response.references : []
    const references: TenantContextDocument[] = rawReferences.map((ref: TenantContextDocumentApi) => {
      const { is_context_file, isContextFile, ...rest } = ref
      return {
        ...rest,
        isContextFile: typeof isContextFile === 'boolean' ? isContextFile : Boolean(is_context_file),
      }
    })
    const responsePagination: any = response && response.pagination ? response.pagination : {}

    const firstDefined = (...values: any[]) => {
      for (const value of values) {
        if (value != null) {
          return value
        }
      }
      return undefined
    }

    const rawPage = firstDefined(
      responsePagination.page,
      responsePagination.currentPage,
      responsePagination.current_page,
      responsePagination.Page,
      (response as any).page,
      (response as any).currentPage,
      (response as any).current_page,
      (response as any).Page
    )
    const rawLimit = firstDefined(
      responsePagination.limit,
      responsePagination.pageSize,
      responsePagination.page_size,
      responsePagination.Limit
    )
    const rawTotalRows = firstDefined(
      responsePagination.totalRows,
      responsePagination.total_rows,
      responsePagination.TotalRows,
      (response as any).totalRows,
      (response as any).total_rows
    )
    const rawTotalPages = firstDefined(
      responsePagination.totalPages,
      responsePagination.total_pages,
      responsePagination.TotalPages,
      (response as any).totalPages,
      (response as any).total_pages
    )

    const parsedPage = Number(rawPage)
    const parsedLimit = Number(rawLimit)
    const parsedTotalRows = Number(rawTotalRows)
    const parsedTotalPages = Number(rawTotalPages)

    // Keep page as 0 when absent/invalid so caller can fallback to requested page.
    const page = Number.isFinite(parsedPage) && parsedPage > 0 ? parsedPage : 0
    const limit = Number.isFinite(parsedLimit) && parsedLimit > 0 ? parsedLimit : references.length || 5
    const totalRows = Number.isFinite(parsedTotalRows) && parsedTotalRows >= 0 ? parsedTotalRows : references.length
    const totalPages = Number.isFinite(parsedTotalPages) && parsedTotalPages > 0
      ? parsedTotalPages
      : Math.max(1, Math.ceil(totalRows / Math.max(1, limit)))

    state.tenantContextDocuments = references
    state.tenantContextDocumentsPagination = {
      page,
      limit,
      totalRows,
      totalPages,
    }
  },
}
